export const RoutePath = {
  DailyOverview: "/overview",
  Feed: "/",
  Queue: "/queue",
  Backlog: "/backlog",
  Sources: "/sources",
  Discover: "/discover",
  Stats: "/stats",
  Settings: "/settings",
  Pricing: "/pricing",
  FeedHistory: "/feed-history",
  Swipe: "/swipe",
  QueuePlay: "/queue/play",
  ArticleReader: "/article/:id",
  Onboarding: "/onboarding",
  SignIn: "/sign-in",
  SignUp: "/sign-up",
  ExtensionAuth: "/extension-auth",
  Charts: "/charts",
  ExtensionAuthCallback: "/extension-auth-callback",
  YouTubeIosOAuthCallback: "/youtube-ios-callback",
} as const;

/** External URLs (open in new tab) */
export const ExternalUrl = {
  Docs: "https://feedkiwi.com/docs/getting-started/what-is-feedkiwi/",
} as const;
